import { queryKeys } from 'config/queryKeys'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'

type UseRequestBulkPayoutMutationProps = {
	checkedUsers: number[]
	clearSelection: () => void
	closeBulkPayoutModal: () => void
}

export const useRequestBulkPayoutMutation = ({
	checkedUsers,
	clearSelection,
	closeBulkPayoutModal
}: UseRequestBulkPayoutMutationProps) => {
	const axiosPrivate = useAxiosPrivate()
	const { t } = useTranslation()
	const queryClient = useQueryClient()

	const { mutate: requestBulkPayoutMutation } = useMutation({
		mutationFn: () => {
			// TODO: change to apiRoutes
			return axiosPrivate.post('/accounts/prepare_payout/', { ids: checkedUsers })
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Payout request succeeded')
			})()

			queryClient.invalidateQueries({ queryKey: queryKeys.users.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			clearSelection()
			closeBulkPayoutModal()
		}
	})

	return {
		requestBulkPayoutMutation
	}
}
